/*
 *		Copyright (c) 2011-2017 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('multiResultsArray', function(){
        return function(elements, callback){ // callback method should return a promise, for the specific action, to perform on each node on the list
            var array = [];
            angular.forEach(elements, function(element){
                var promise = function(){
                    return callback(element);
                };
                array.push({name: element.name, is_directory: element.is_directory, promise: promise});
            });

            return array;
        };
    });


